export const serviceOnlinecheckout = [
	// Онлайн-кассы
	{
		name: 'Облачная онлайн-касса',
		location: 'Онлайн-касса',
		url: '/online-kassa#block1',
	},
	{
		name: 'Возможности облачной кассы для интернет-магазина',
		location: 'Онлайн-касса',
		url: '/online-kassa#block2',
	},
	{
		name: 'Преимущества виртуальной онлайн-кассы',
		location: 'Онлайн-касса',
		url: '/online-kassa#block3',
	},
	{
		name: 'Комплексное решение',
		location: 'Онлайн-касса',
		url: '/online-kassa#block3Title1',
	},
	{
		name: 'Удобство',
		location: 'Онлайн-касса',
		url: '/online-kassa#block3Title2',
	},
	{
		name: 'Надёжность',
		location: 'Онлайн-касса',
		url: '/online-kassa#block3Title3',
	},
	{
		name: 'Гибкость',
		location: 'Онлайн-касса',
		url: '/online-kassa#block3Title4',
	},
	{
		name: 'Как подключить онлайн-кассу',
		location: 'Онлайн-касса',
		url: '/online-kassa#block4',
	},
];
